/**
 * Reusable component representing a list item with a title and an
 * optional subtitle with a right-facing chevron.
 */

import * as React from 'react'

import { IconButton } from '@doordash/component-button'
import ComponentListCell from '@doordash/component-list-cell'
import { Icon, Colors } from '@doordash/design-language'
import { StyledListCellMenuItem, StyledStatusIndicator } from './styles'

import { DeliveryIssueStatus } from '../../../../models/types'

type ReadStatusIndicatorProps = {
  status: DeliveryIssueStatus
}

export const ReadStatusIndicator: React.FC<ReadStatusIndicatorProps> = ({
  status,
}) => (
  <StyledStatusIndicator>
    <Icon
      type={Icon.Types.LogoDashpass}
      color={
        status === DeliveryIssueStatus.Unread
          ? Icon.Colors.SystemBlue60
          : Icon.Colors.SystemWhite
      }
      size={Icon.Sizes.Tiny}
    />
  </StyledStatusIndicator>
)

type ListCellMenuItemProps = {
  status?: DeliveryIssueStatus
  subtitle?: string
  title: string
  onClick?: () => void
}

export const ListCellMenuItem: React.FC<ListCellMenuItemProps> = props => (
  <StyledListCellMenuItem status={props.status}>
    <ComponentListCell
      renderBeforeContent={
        /**
         * Show status indicator if there is a status. Otherwise, show nothing
         * so other uses of ListCellMenuItem don't have an indentation.
         */
        Object.values(DeliveryIssueStatus).includes(props.status)
          ? () => <ReadStatusIndicator status={props.status} />
          : undefined
      }
      title={props.title}
      secondaryTitleEnd={props.subtitle ? props.subtitle : ''}
      size={ComponentListCell.Sizes.Small}
      iconEnd={{
        type: ComponentListCell.IconTypes.ChevronRight,
        accessibilityLabel: `Go to: ${props.title}`,
        size: IconButton.Sizes.Medium,
        color: Colors.TextTertiary,
      }}
      separatorType={ComponentListCell.SeparatorTypes.FullBorder}
      titleMaxLines={2}
      {...props}
    />
  </StyledListCellMenuItem>
)

export default ListCellMenuItem
